import { Navigate } from "react-router"
import { ProtectedRoute } from "@/lib/auth/protected-route"
import { useOrganization } from "@/lib/organization/organization-context"
import { Roles } from "@/lib/team/roles"

// Legacy /team route — redirects to the active team's Members page in the
// new Settings IA. The old page composed an unstyled members list + invite
// form; that surface is now Settings → {entity} → Members & invites.
// Drop this route after one release.
export default function TeamPage() {
  return (
    <ProtectedRoute allowedRoles={[Roles.Director, Roles.GeneralManager, Roles.ServiceManager]}>
      <Redirect />
    </ProtectedRoute>
  )
}

function Redirect() {
  const { activeGroup, activeDealershipId, activeBodyShopId } = useOrganization()
  const target = activeDealershipId
    ? `/settings/dealership/${activeDealershipId}/members`
    : activeBodyShopId
      ? `/settings/bodyshop/${activeBodyShopId}/members`
      : activeGroup
        ? `/settings/group/${activeGroup.id}/members`
        : "/settings/account"
  return <Navigate to={target} replace />
}
